"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = exports.testIds = exports.DEFAULT_NOTIFICATIONS_PAGE_SIZE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_router_dom_1 = require("react-router-dom");
const PlaceholderEmptyNotifications_1 = require("../assets/PlaceholderEmptyNotifications");
const PlaceholderReadAllNotifications_1 = require("../assets/PlaceholderReadAllNotifications");
const useNotificationListState_1 = require("../hooks/useNotificationListState");
const translations_1 = require("../types/translations");
const NotificationDetails_1 = require("./NotificationDetails");
const NotificationList_1 = require("./NotificationList");
const NotificationListFilters_1 = require("./NotificationListFilters");
const NotificationListSortBy_1 = require("./NotificationListSortBy");
const NotificationPlaceholder_1 = require("./NotificationPlaceholder");
exports.DEFAULT_NOTIFICATIONS_PAGE_SIZE = 50;
exports.testIds = {
    pagination: 'notification_center-pagination',
    loader: 'notification_center-loader',
    listContainer: 'notification_center-list_container',
};
const trackingIds = {
    paginationBack: 'notification_center-pagination-back',
    paginationNext: 'notification_center-pagination-next',
    paginationPageSizeChange: 'notification_center-pagination-page_size_change',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: {
        width: 450,
        borderRight: `1px solid ${theme.palette.divider}`,
        height: '100%',
    },
    notificationsWrapper: {
        height: 'calc(100% - 78px)',
    },
    leftSection: {
        height: '100%',
    },
    titleSection: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    listWrapper: {
        flex: 1,
        overflow: 'auto',
        overflowX: 'hidden',
    },
    pagination: {
        color: theme.palette.text.primary,
        background: theme.palette.background.paper,
    },
    paginationToolbar: {
        minHeight: 0,
        height: theme.spacing(6),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    paginationActions: {
        '& button': {
            padding: theme.spacing(1.2),
        },
    },
    rightSection: {
        flex: 1,
        height: '100%',
    },
    emptyIcon: {
        width: 91,
        height: 120,
    },
    readAllIcon: {
        height: 130,
        width: 126,
    },
}));
const Notifications = () => {
    const classes = useStyles();
    const history = (0, react_router_dom_1.useHistory)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const theme = (0, silhouette_core_1.useTheme)();
    const { page, pageSize, onPageChange, updatePageSize, pageCount, notificationResults, selectedNotification, isFiltersApplied, } = (0, useNotificationListState_1.useNotificationListState)();
    const handlePageChange = (_, currentPage) => {
        history.push(`/notification-center`);
        onPageChange(_, currentPage);
    };
    const showPagination = () => {
        return ((0, jsx_runtime_1.jsx)(silhouette_core_1.TablePagination, { "data-testid": exports.testIds.pagination, component: "section", count: pageCount, page: page - 1, rowsPerPage: pageSize, onPageChange: handlePageChange, rowsPerPageOptions: [exports.DEFAULT_NOTIFICATIONS_PAGE_SIZE, 75, 100], onRowsPerPageChange: (event) => updatePageSize(Number(event.target.value)), labelRowsPerPage: translate(translations_1.notificationsListTranslations.paginationRowsPerPage), classes: {
                root: classes.pagination,
                toolbar: classes.paginationToolbar,
                actions: classes.paginationActions,
            }, backIconButtonProps: {
                'data-tracking-id': trackingIds.paginationBack,
            }, nextIconButtonProps: {
                'data-tracking-id': trackingIds.paginationNext,
            }, SelectProps: {
                'data-tracking-id': trackingIds.paginationPageSizeChange,
            } }));
    };
    const isNotificationsEmpty = !notificationResults?.data?.results?.length;
    if (notificationResults.isLoading) {
        return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", height: "100%", "data-testid": exports.testIds.loader, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CircularProgress, {}) }));
    }
    if (!notificationResults.data) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, className: classes.notificationsWrapper, wrap: "nowrap", "data-testid": exports.testIds.listContainer, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { className: classes.leftSection, children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { className: classes.container, flex: 1, display: "flex", flexDirection: "column", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { px: 2.5, py: 1.25, className: classes.titleSection, children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, alignItems: "center", justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Typography, { variant: "h6", children: [translate(translations_1.notificationsListTranslations.title), ' ', !!notificationResults.data.total && `(${notificationResults.data.total})`] }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(NotificationListSortBy_1.NotificationListSortBy, {}) })] }) }), (0, jsx_runtime_1.jsx)(NotificationListFilters_1.NotificationListFilters, {}), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { className: classes.listWrapper, children: notificationResults.isFetching ? ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", height: "100%", "data-testid": exports.testIds.loader, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CircularProgress, {}) })) : ((0, jsx_runtime_1.jsx)(NotificationList_1.NotificationList, { list: notificationResults.data.results, selectedNotification: selectedNotification, identifier: "notification_center", isFiltersApplied: isFiltersApplied })) }), !isNotificationsEmpty && showPagination()] }) }), (0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { className: classes.rightSection, children: [isNotificationsEmpty && ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", alignItems: "center", height: "100%", bgcolor: theme.palette.background.default, children: (0, jsx_runtime_1.jsx)(PlaceholderReadAllNotifications_1.PlaceholderReadAllNotifications, { className: classes.readAllIcon }) })), !isNotificationsEmpty &&
                        (selectedNotification ? ((0, jsx_runtime_1.jsx)(NotificationDetails_1.NotificationDetails, { selectedNotification: selectedNotification })) : ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", alignItems: "center", height: "100%", children: (0, jsx_runtime_1.jsx)(NotificationPlaceholder_1.NotificationPlaceholder, { icon: (0, jsx_runtime_1.jsx)(PlaceholderEmptyNotifications_1.PlaceholderEmptyNotifications, { className: classes.emptyIcon }), title: translate(translations_1.notificationDetailTranslations.empty), description: translate(translations_1.notificationDetailTranslations.emptyDescription) }) })))] })] }));
};
exports.Notifications = Notifications;
//# sourceMappingURL=Notifications.js.map